var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-logo-container"},[_c('router-link',{staticClass:"sidebar-logo-link",attrs:{"to":"/"}},[_c('h1',{staticClass:"sidebar-title"},[_vm._v("福鼎市零工市场")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }